import { render, staticRenderFns } from "./InnerScrollLongContentModal.vue?vue&type=template&id=94c15dd4"
import script from "./InnerScrollLongContentModal.vue?vue&type=script&lang=js"
export * from "./InnerScrollLongContentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports